export default __webpack_public_path__ + "static/media/icon-highlight-awards.d3fe7b34.svg";